import dayjs from "dayjs"
import BaseTableRow from "../../../components/layout/BaseTableRow"
import { AbsenceType } from "../types"
import { Popover, Tag } from "antd"
import { ReactComponent as CLOSE } from "../../../assets/CloseICON.svg"
import { AbsenceStatus } from "../types"
import { ReactComponent as CHECK } from "../../../assets/ApprovaICON.svg"
import { AbsencesTypes } from "../../../api/constants"

type AbsenceTableRowType = {
    absence: AbsenceType
    openAbsenceModal: () => void
    handleUpdateAbsence: (id: string, body: AbsenceType) => void
    userIsEmployee: boolean
}

export default function AbsenceTableRow(props: AbsenceTableRowType) {
    return (
        <BaseTableRow onClick={props.openAbsenceModal}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[4rem]">
                    {props.absence.conflictingAbsences && props.absence.conflictingAbsences?.length && !props.userIsEmployee ? "❗️" : ""} {props.absence.type}
                </p>
            </td>
            <td className={`${props.userIsEmployee ? "hidden" : "table-cell"}`}>
                <p className="line-clamp-1 text-center min-w-[6rem]">
                    {props.absence.employee?.first_name} {props.absence.employee?.last_name}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.absence.createdAt).format("DD.MM.YYYY")}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.absence.startDate).format("DD.MM.YYYY")}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.absence.endDate).format("DD.MM.YYYY")}</p>
            </td>
            <td className="hidden lg:table-cell">
                <p className="line-clamp-1 text-center">{props.absence.comment ?? "Keine Notiz"}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">
                    <Tag
                        className="w-32 text-center"
                        color={
                            props.absence.type === AbsencesTypes.SICK
                                ? "gray"
                                : props.absence.status === AbsenceStatus.IN_REVIEW
                                ? "gold"
                                : props.absence.status === AbsenceStatus.REJECTED
                                ? "red-inverse"
                                : "green"
                        }>
                        {props.absence.type === AbsencesTypes.SICK ? "Krank" : props.absence.status}
                    </Tag>
                </p>
            </td>
            <td className={`${props.userIsEmployee ? "hidden" : "table-cell"}`} onClick={(event) => event.stopPropagation()}>
                {props.absence.status === AbsenceStatus.IN_REVIEW && (
                    <div className="flex gap-8 z-10">
                        <Popover
                            placement="bottomLeft"
                            title="Ablehnen?"
                            content={
                                <div className="flex flex-col items-end max-w-[20rem]">
                                    <p>Sie lehnen die Anfrage ab. Der Mitarbeiter wird die Ablehnung im Dashboard sehen.</p>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            props.handleUpdateAbsence(props.absence._id, { status: AbsenceStatus.REJECTED } as AbsenceType)
                                        }}
                                        className="btn btn-sm btn-primary w-fit mt-1">
                                        OK
                                    </button>
                                </div>
                            }>
                            <CLOSE className="w-6 h-6 cursor-pointer" />
                        </Popover>
                        <Popover
                            placement="bottomLeft"
                            title="Genehmigen?"
                            content={
                                <div className="flex flex-col items-end max-w-[20rem]">
                                    <p>Sie genehmigen die Abwesenheit. Der Mitarbeiter wird die Genehmigung im Dashboard sehen.</p>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            props.handleUpdateAbsence(props.absence._id, { status: AbsenceStatus.APPROVED } as AbsenceType)
                                        }}
                                        className="btn btn-sm btn-primary w-fit mt-1">
                                        OK
                                    </button>
                                </div>
                            }>
                            <CHECK className="w-6 h-6 cursor-pointer" />
                        </Popover>
                    </div>
                )}
            </td>
        </BaseTableRow>
    )
}
